import { useEffect, useState } from "react"

/**
 * True below the Tailwind `md` breakpoint (768px). SSR-safe: false on the
 * server and on the first client render, then tracks the media query.
 * Use it to switch a Modal to its full-screen variant on phones.
 */
export default function useIsMobile(query = "(max-width: 767px)") {
  const [mobile, setMobile] = useState(false)
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return
    const mq = window.matchMedia(query)
    const update = () => setMobile(mq.matches)
    update()
    mq.addEventListener?.("change", update)
    return () => mq.removeEventListener?.("change", update)
  }, [query])
  return mobile
}
